import type { UseCaseType } from '../models/UseCase';

export type GenogramStartMode = 'genogram-blank-direct' | 'genogram-scenario';

export interface GenogramStartParams {
  onboardingMode: GenogramStartMode;
  useCase?: UseCaseType;
  startView?: 'blank';
}

export interface GenogramStartCard {
  key: GenogramStartMode;
  params: GenogramStartParams;
  testId: string;
}

export const GENOGRAM_EMPTY_HERO_CARDS: readonly GenogramStartCard[] = [
  {
    key: 'genogram-blank-direct',
    params: {
      onboardingMode: 'genogram-blank-direct',
      useCase: 'blank',
      startView: 'blank',
    },
    testId: 'tid.dashboard.emptyState.genogram.genogram-blank-direct',
  },
  {
    key: 'genogram-scenario',
    params: {
      onboardingMode: 'genogram-scenario',
    },
    testId: 'tid.dashboard.emptyState.genogram.genogram-scenario',
  },
];

export const GENOGRAM_WIZARD_GRID_TEST_ID = 'tid.genogram-wizard.use-case-grid';
export const GENOGRAM_WIZARD_START_TEMPLATE_TEST_ID = 'tid.genogram-wizard.start-template';

export function buildGenogramStartUrl(folderId: string, params: GenogramStartParams): string {
  const search = new URLSearchParams({ type: 'genogram' });
  Object.entries(params).forEach(([key, value]) => {
    if (value) search.set(key, value);
  });
  return `/f/${encodeURIComponent(folderId)}/d/new?${search.toString()}`;
}

export function getGenogramWizardCardTestId(useCaseId: UseCaseType): string {
  return `tid.genogram-wizard.card.${useCaseId}`;
}
